import { DrupalIdentifier } from './drupal-node.model';
import { DrupalTreeItem } from './drupal-menu-item';

export class DrupalTreeUI {
  items!: DrupalTreeItemUI[];
}

export class DrupalTreeItemUI {
  label!: string;
  path!: string;
  items!: DrupalTreeItemUI[];
}

export class Tree<T> {
  items!: T[];
}

export class TreeItem<T> {
  [id: string]: any;

  ref!: DrupalIdentifier;
  depth!: number;
  items!: TreeItem<T>[];
  parent!: DrupalIdentifier;
  title!: string;
  path!: string | undefined;
  index!: number;
}

export function buildMenu<T extends TreeItem<T>>(
  menuItems: DrupalTreeItem[],
  menu: Tree<T> | null = null
): Tree<T> {
  if (!menu) {
    menu = new Tree();
    menu.items = [];
  }

  menuItems = menuItems.sort((a, b) => a.weight - b.weight);

  const menuItemWrappers = menuItems.map((menuItem, index) => {
    const menuItemWrapper = new TreeItem();
    Object.keys(menuItem).forEach((key) => {
      menuItemWrapper[key] = menuItem[key];
    });
    menuItemWrapper.title = menuItem.title;
    menuItemWrapper.path = menuItem.path;
    menuItemWrapper.ref = { type: menuItem.type, id: menuItem.id };
    menuItemWrapper.index = index;
    return menuItemWrapper as T;
  });

  menuItemWrappers.forEach((menuItemWrapper) => {
    const originalItem = menuItems.find(
      (mi) => mi.id === menuItemWrapper.ref.id
    );
    if (originalItem) {
      if (!originalItem.parentId) {
        menu?.items.push(menuItemWrapper);
      } else {
        const parentWrapper = menuItemWrappers.find(
          (miw) => miw.ref.id === originalItem.parentId
        );
        if (parentWrapper) {
          if (!parentWrapper.items) {
            parentWrapper.items = [];
          }
          parentWrapper.items.push(menuItemWrapper);
          menuItemWrapper.parent = {
            type: parentWrapper.ref.type,
            id: parentWrapper.ref.id,
          };
        }
      }
    }
  });
  setDepth<T>(menu.items);
  return menu as Tree<T>;
}

export function setDepth<T>(parentItems: TreeItem<T>[] | undefined, depth = 0) {
  if (parentItems) {
    parentItems.forEach((item) => {
      item.depth = depth;
      setDepth<T>(item.items, depth + 1);
    });
  }
}
